import memberstackDOM from '@memberstack/dom';

const publicKey = process.env.REACT_APP_MEMBERSTACK_PUBLIC_KEY;

const memberstack = publicKey
  ? memberstackDOM.init({
      publicKey,
    })
  : null;

export default memberstack;